<template>
    <div :class="b()">
        <div>
            <div v-if="prototypes.length < 1 && this.hasProt === false" class="col-sm-12 no-favorites noitem-message">
                У Вас нет ни одного избранного товара
            </div>
        </div>

        <div v-for="prototype in this.prototypes" class="buyingcard -style-buyer">

            <div class="buyingcard__col -col-1 image">
                <img :src="prototype.item_image" class="image1" alt="">
            </div>

            <div class="buyingcard__col -col-3">
                <div class="w100 buyingcard__list">
                    <div class="buyingcard__title title">Название:</div>
                    <a v-bind:href="'/catalog/default/prototype-view?cat=' + prototype.category_id + '&favorite=' + prototype.id">
                        <div class="buyingcard__title value">{{prototype.full_title}}</div>
                    </a>
                </div>
            </div>

            <div class="buyingcard__col -col-4">
                <div class="buyingcard__title title">Цена:</div>
                <div class="buyingcard__title value">{{prototype.item_price + ' Руб.'}}</div>
            </div>

            <i v-on:click="removeFavorite(prototype)" class="fa fa-times remove link"></i>

        </div>

    </div>
</template>

<script>

    import FavoriteService from "../services/FavoriteService";
    import ItemService from "../services/ItemService";

    const COMPONENT_NAME = "prototype-favorite";

    export default {
        name: COMPONENT_NAME,
        data() {
            return {
                prototypes: '',
                prototypeTitle: '',
                prototypeImage: '',
                prototypePrice: '',
                hasProt: true
            }
        },
        mounted() {
            this.getFavorite();
        },
        computed: {},
        methods: {
            async getFavorite() {
                let response = await FavoriteService.getFavorites();
                if (response.success) {
                    this.prototypes = response.favorites;
                } else {
                    this.hasProt = false;
                }
            },
            async removeFavorite(prototype) {
                if (prototype) {
                    let response = await FavoriteService.removeFavorite(prototype.id);
                    if (response.success) {
                        this.prototypes.splice(this.prototypes.indexOf(prototype), 1);
                        let text = this.$createElement('span', 'Товар удален из избранного');

                        let message = this.$createElement('div', [
                            text
                        ]);

                        this.$notify({message: message, type: 'success'});

                        this.prototypes.length > 0 ? this.hasProt = true : this.hasProt = false;
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .buyingcard {
        padding: 8px 15px 8px 15px;

        .title {
            color: #999;
            font-size: 17px;
        }

        .value {
            font-size: 17px;
            color: unset;
        }

    }

    .image {

        .image1 {
            display: block;
            padding-right: 15px;
            margin: auto;
            max-height: 80px;
        }
    }

    .remove {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 9999;
    }

    .no-favorites {
        text-align: center;
    }
</style>